/**
 * Sample form data for auto-fill on Promotion Record create page.
 * Only fills salary, date, reason, and flags — employee and position/level must be selected by user.
 */
export type PromotionRecordFormSample = {
    previousSalary: number;
    newSalary: number;
    promotedAt: string;
    reason: string;
    applyToEmployee: boolean;
    enforceRule: boolean;
};

export const promotionRecordFormSamples: PromotionRecordFormSample[] = [
    {
        previousSalary: 3_200_000,
        newSalary: 3_800_000,
        promotedAt: new Date().toISOString().slice(0, 10),
        reason: 'ຜົນງານດີ ເກີດການເລື່ອນຂັ້ນຕາມກົດເສັ້ນທາງ.',
        applyToEmployee: true,
        enforceRule: true,
    },
    {
        previousSalary: 4_500_000,
        newSalary: 5_200_000,
        promotedAt: new Date().toISOString().slice(0, 10),
        reason: 'ເຕີບໂຕຈາກ Senior ເປັນ Lead ຕາມປະສົບການ.',
        applyToEmployee: true,
        enforceRule: true,
    },
    {
        previousSalary: 2_800_000,
        newSalary: 3_200_000,
        promotedAt: new Date().toISOString().slice(0, 10),
        reason: 'ປະຈຳເດືອນປະຈຳປີ ຕາມນະໂຍບາຍບໍລິສັດ.',
        applyToEmployee: false,
        enforceRule: false,
    },
    {
        previousSalary: 5_500_000,
        newSalary: 6_500_000,
        promotedAt: new Date().toISOString().slice(0, 10),
        reason: 'ເລື່ອນຂັ້ນເປັນຕຳແໜ່ງບັນຊາ ຫຼັກການຄຸ້ມຄອງ.',
        applyToEmployee: true,
        enforceRule: true,
    },
    {
        previousSalary: 1_800_000,
        newSalary: 2_200_000,
        promotedAt: new Date().toISOString().slice(0, 10),
        reason: 'ຜ່ານການປະເມີນຫຼັງທົດສອບວຽກ ເປັນພະນັກງານປົກກະຕິ.',
        applyToEmployee: true,
        enforceRule: false,
    },
];
